import { render, staticRenderFns } from "./StatementReport.vue?vue&type=template&id=b3a5ff6c&scoped=true"
import script from "./StatementReport.vue?vue&type=script&lang=js"
export * from "./StatementReport.vue?vue&type=script&lang=js"
import style0 from "./StatementReport.vue?vue&type=style&index=0&id=b3a5ff6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a5ff6c",
  null
  
)

export default component.exports